import { useSelector } from 'react-redux'

import { Navigate, Outlet } from 'react-router-dom'
import { toast } from 'react-toastify'

import { authSelector } from '@/stores/auth/authSlice'
import { shareSomeElements } from '@/utils/arrayHelper'

const AuthMiddleware = ({ userRoles, userRights = [], contributorGroups = [], children }) => {
  const { user } = useSelector(authSelector)

  // if (
  //   !userRoles.includes(user?.role) &&
  //   !shareSomeElements(userRights, user?.editRights) &&
  //   !contributorGroups.includes(user?.contributorGroup)
  // ) {
  //   return <Navigate to="/accessDenied" />
  // }

  return <>{children}</>
}

export default AuthMiddleware
